// extracted by mini-css-extract-plugin
module.exports = {"title":"ServiceSectionsList-module__title___3VUmM"};